import type React from 'react';

interface Props {
  children?: React.ReactNode;
}

export default function ({ children }: Props) {
  return (
    <div className="flex h-full w-full grow flex-col space-y-4 overflow-y-auto rounded-md border p-2">{children}</div>
  );
}
